import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useTheme, useStore } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import {
    APIS,
    SF_CSTM_OFCR_INFO,
    SG_USR_ROLE_HIST_LIST,
    SG_USR_ROLE_HIST_EXCEL_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/rolehist/services/PtliRoleHistService";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { comnUtils } from "@/comn/utils";

/*
 * Select. Custom Office User Auth History Detail
 * !== 세관 사용자 권한 이력 상세 ==!
 */
export const PTLI1003008Q = (): JSX.Element => {
    const modal = useModal();
    const param = useParams();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면
    const { t } = useTranslation();
    const [load, setLoad] = useState(false);

    const form = {
        cstmOfcrInfo: useForm({
            defaultSchema: SF_CSTM_OFCR_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        usrRoleHistList: useGrid({ defaultSchema: SG_USR_ROLE_HIST_LIST, page: pgeStore?.page, size: pgeStore?.size }),

        usrRoleHistExcelList: useGrid({
            defaultSchema: SG_USR_ROLE_HIST_EXCEL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmUsrDta: useFetch({
            api: () => APIS.getCstmUsrDta({ usrDmnId: param["usrDmnId"] }),
            onSuccess: (data: any) => {
                const { content } = data.usrInfo;
                form.cstmOfcrInfo.setValues(content);
                fetch.getCstmUsrRoleList.fetch();
                //console.log("im here");
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getCstmUsrRoleList: useFetch({
            api: (page = grid.usrRoleHistList.page, size = grid.usrRoleHistList.size) =>
                APIS.getUsrRoleHistList({ usrDmnId: param["usrDmnId"] }, page, size),
            enabled: true,
            key: [grid.usrRoleHistList.page, grid.usrRoleHistList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOfcrInfo.getValues(),
                    page: grid.usrRoleHistList.page,
                    size: grid.usrRoleHistList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        getCstmUsrRoleExcelList: useFetch({
            api: (data: any) => (load ? APIS.getUsrRoleHistExcelList(data) : null),
            enabled: comnUtils.isEmpty(form.cstmOfcrInfo.errors),
            onSuccess: (data) => {
                if (load) {
                    console.log(data);
                    grid.usrRoleHistExcelList.exportExcel({
                        excelName: `${t("L_INT_PTL")}_User Roles List Details_${t("T_USR_INFO")}_${dayjs().format(
                            "DD/MM/YYYY HHmm",
                        )}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const render = {
        cell: {
            attchFle: (props: any) => {
                const rowData = props.rowValues;

                const bsopId = rowData.fileSaveDto?.fileSaveReqDtoList?.[0]?.bsopId || rowData.roleId;

                console.log(bsopId);

                return rowData.roleMemoFileUuid ? (
                    <Group.Control type="file" value={bsopId} edit={false} />
                ) : (
                    <p>No file</p>
                );
            },
        },
    };

    const handler = {};

    useEffect(() => {
        fetch.getCstmUsrDta.fetch();
    }, [theme]);

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getCstmUsrRoleExcelList.fetch(store.form);
        }
    }, [load]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.sctnNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.unitNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrDmnId} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmOfcrNo} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrTelno} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrEmlAddr} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    setLoad(true);
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Group.Section gap={2}>
                        <Grid
                            {...grid.usrRoleHistList.grid}
                            data={fetch.getCstmUsrRoleList.data?.usrRoleHistList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Button role={"list"} onClick={() => navigate(`${URLS.ptli1003007q}`)} />
                </Layout.Left>
            </Layout>
            <Group hidden>
                <Grid {...grid.usrRoleHistExcelList.grid} data={fetch.getCstmUsrRoleExcelList.data?.usrRoleHistList} />
            </Group>
        </Page>
    );
};
